export * from './src/social-groups-v2-group-role-roles.meta.js';
